import { render, staticRenderFns } from "./memberListPage.vue?vue&type=template&id=23c4b6fb&"
import script from "./memberListPage.vue?vue&type=script&lang=ts&"
export * from "./memberListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports